import CustomScrollbar from '@r1-frontend/ui-react/components/CustomScrollbar';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

const scrollIndent = 10; // Отступ скрола от контента
const defaultMaxContentHeight = 'calc(100vh - 200px)'; // Ограничения по высоте для контента скролла.

interface IProps {
    children: JSX.Element | JSX.Element[],
    maxContentHeight?: string,
}

/**
 * Компонент скрола, с отступом 'scrollIndent' от контента
 */
export const ScrollbarWithIndent = ({
    children,
    maxContentHeight = defaultMaxContentHeight,
}: IProps) => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    return <CustomScrollbar
        customStyles={{
            view: {
                paddingRight: isMobile ? 0 : `${scrollIndent}px`,
                paddingBottom: 0,
            },
        }}
        autoHeight
        autoHeightMin={150}
        autoHeightMax={maxContentHeight}
        style={{
            width: isMobile ? '100%' : `calc(100% + ${scrollIndent}px)`,
        }}
    >
        {children}
    </CustomScrollbar>;
};
